import { supabase } from './utils/supabaseClient';
import { trackEventRaw } from './utils/track';
import { takeHandoff } from './handoffCapture';

/* SESSION-ÁTVÉTEL A LANDINGRŐL — 2. lépés: belépés a tokenekkel.

   Egyetlen közös promise: StrictMode dupla effektje mellett is pontosan
   egyszer fut, és mindenki ugyanarra az eredményre vár. Mindig teljesül —
   hibás vagy lejárt tokennél a user kijelentkezve marad, és az EmailGate
   fogadja. A címsor ekkorra már tiszta (handoffCapture.js).

   Mérés: a landing sessionHandoff.js-ével azonos események és mezők. */

let settled = null;

export function settleHandoff() {
  if (settled) return settled;
  const captured = takeHandoff();
  if (!captured) {
    settled = Promise.resolve();
    return settled;
  }
  const { access_token, refresh_token, variant } = captured;
  settled = supabase.auth.setSession({ access_token, refresh_token })
    .then(({ error }) => {
      if (error) {
        trackEventRaw('session_handoff_failed', {
          page: 'terminal', variant, stage: 'set_session',
          message: String(error.message || '').slice(0, 200),
        });
        return;
      }
      trackEventRaw('session_handoff_ok', { page: 'terminal', variant });
    })
    .catch((e) => {
      trackEventRaw('session_handoff_failed', {
        page: 'terminal', variant, stage: 'exception',
        error: String(e?.name || 'unknown'),
        message: String(e?.message || '').slice(0, 200),
      });
    });
  return settled;
}
